<div class="mat-elevation-z8 basecanvas" style="text-align: center;">
  <br><h2>아이템 및 조합법 자료 생성 도구</h2>
  <br><a routerLink="/dev/equip_recipe" class="nohighlight">조합식 생성하기</a> <br>
  <br><a routerLink="/dev/equip" class="nohighlight">장비정보 생성하기</a> <br>
  <br><a routerLink="/dev/codetable" class="nohighlight">장비 코드테이블</a> <br>
  <br><br>
</div>
